// frontend/src/services/chatService.js
import apiClient from './apiClient';

const API_URL = '/';

const enviarMensaje = (mensaje, usuarioId, conversacionId = null) => {
    return apiClient.post(`/chat/mensaje`, {
        mensaje,
        usuarioId,
        conversacionId
    });
};

const obtenerRecordatorios = (usuarioId) => {
    return apiClient.get(`/chat/recordatorios/${usuarioId}`);
};

const crearRecordatorio = (recordatorioData) => {
    return apiClient.post(`/chat/recordatorio`, recordatorioData);
};

const obtenerSugerencias = (usuarioId) => {
    return apiClient.get(`/chat/sugerencias/${usuarioId}`);
};

const obtenerEstadisticas = () => {
    return apiClient.get(`/chat/estadisticas`);
};

const ChatService = {
    enviarMensaje,
    obtenerRecordatorios,
    crearRecordatorio,
    obtenerSugerencias,
    obtenerEstadisticas
};

export default ChatService;